declare namespace $ {

	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_preview_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_preview_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_map_widget_float_notebook_preview_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_map_widget_float_notebook_preview extends $shm_hitalama_map_widget_float_notebook {
		Item_row( id: any): $mol_view
		List( ): $mol_view
		Item( id: any): $mol_view
	}
	
}

//# sourceMappingURL=preview.view.tree.d.ts.map